import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "layout": "full",
  "title": "من نحن",
  "lead": "ماهيته"
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    h2: "h2",
    p: "p",
    ..._provideComponents(),
    ...props.components
  }, {IndicatorRow, IndicatorSection, IndicatorTable, TargetFourLogo, ThemeLabel, Title} = _components;
  if (!IndicatorRow) _missingMdxReference("IndicatorRow", true);
  if (!IndicatorSection) _missingMdxReference("IndicatorSection", true);
  if (!IndicatorTable) _missingMdxReference("IndicatorTable", true);
  if (!TargetFourLogo) _missingMdxReference("TargetFourLogo", true);
  if (!ThemeLabel) _missingMdxReference("ThemeLabel", true);
  if (!Title) _missingMdxReference("Title", true);
  return _jsxs(_Fragment, {
    children: [_jsx(TargetFourLogo, {}), "\n", _jsx(Title, {
      children: " SDG 4 Indicators "
    }), "\n", _jsx(_components.p, {
      children: "Ensure inclusive and equitable quality education and promote lifelong learning opportunities for all"
    }), "\n", _jsxs(IndicatorSection, {
      children: [_jsx(_components.h2, {
        id: "target-41",
        children: "Target 4.1"
      }), _jsxs(_components.p, {
        children: ["٤-١ ضمان أن يتمتّع جميع الفتيات والفتيان بتعليم ابتدائي وثانوي مجاني ومنصف وجيّد يؤدي إلى تحقيق نتائج تعليمية ملائمة وفعالة بحلول عام 2030 ", _jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000385723/PDF/385723eng.pdf.multi.page=236",
          children: "See latest GEM Report chapter"
        })]
      }), _jsxs(IndicatorTable, {
        children: [_jsx(IndicatorRow, {
          id: "4.1.0",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.1/i4.1.0",
          children: _jsx(_components.p, {
            children: "نسبة الأطفال/الشباب المستعدين للمستقبل، بحسب الجنس"
          })
        }), _jsxs(IndicatorRow, {
          id: "4.1.1",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.1/i4.1.1",
          global: true,
          children: [_jsx(_components.p, {
            children: "نسبة الأطفال والشباب: (أ) في الصف الثاني/الثالث؛ (ب) في نهاية المرحلة الابتدائية؛ (جـ) في نهاية المرحلة الدنيا من التعليم الثانوي الذين يحققون على الأقل الحد الأدنى من مستوى الكفاءة في (1) القراءة، (2) الرياضيات، بحسب الجنس."
          }), _jsx(ThemeLabel, {
            theme: "learning",
            id: "4.1.1a"
          })]
        }), _jsx(IndicatorRow, {
          id: "4.1.2",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.1/i4.1.2",
          global: true,
          children: _jsx(_components.p, {
            children: "معدل إكمال الدراسة (التعليم الابتدائي، والتعليم الإعدادي، والتعليم الثانوي)"
          })
        }), _jsx(IndicatorRow, {
          id: "4.1.3",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.1/i4.1.3",
          children: _jsx(_components.p, {
            children: "نسبة القبول الإجمالية في الصف الأخير (المرحلة الابتدائية والمرحلة الدنيا من التعليم الثانوي)."
          })
        }), _jsxs(IndicatorRow, {
          id: "4.1.4",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.1/i4.1.4",
          children: [_jsx(_components.p, {
            children: "نسبة غير الملتحقين بالمدارس (سنة قبل التعليم الابتدائي، التعليم الابتدائي، المرحلة الأولى من التعليم الثانوي، المرحلة الثانية من التعليم الثانوي)"
          }), _jsx(ThemeLabel, {
            theme: "access",
            id: "4.1.4"
          })]
        }), _jsxs(IndicatorRow, {
          id: "4.1.5",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.1/i4.1.5",
          children: [_jsx(_components.p, {
            children: "النسبة المئوية للأطفال الأكبر سناً من عمر صفهم الدراسي (التعليم الابتدائي، المرحلة الأولى من التعليم الثانوي)"
          }), _jsx(ThemeLabel, {
            theme: "access",
            id: "4.1.5"
          })]
        }), _jsxs(IndicatorRow, {
          id: "4.1.6",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.1/i4.1.6",
          children: [_jsx(_components.p, {
            children: "تنظيم عملية لتقييم التعلّم على المستوى الوطني (أ) في الصف الثاني/الثالث؛ و(ب) في نهاية المرحلة  الابتدائية؛ و(ج) في نهاية المرحلة الأولى من التعليم الثانوي"
          }), _jsx(ThemeLabel, {
            theme: "access",
            id: "4.1.6"
          })]
        }), _jsx(IndicatorRow, {
          id: "4.1.7",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.1/i4.1.7",
          children: _jsx(_components.p, {
            children: "عدد سنوات التعليم (1) المجاني و(2) الإلزامي في الابتدائي والثانوي المضمون بموجب الأُطر القانونية."
          })
        })]
      })]
    }), "\n", _jsxs(IndicatorSection, {
      children: [_jsx(_components.h2, {
        id: "target-42",
        children: "Target 4.2"
      }), _jsxs(_components.p, {
        children: ["ضمان أن تتاح لجميع البنات والبنين فرص الحصول على نوعية جيدة من النماء والرعاية في مرحلة الطفولة المبكرة والتعليم قبل الابتدائي حتى يكونوا جاهزين للتعليم الابتدائي بحلول عام 2030\n", _jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000385723/PDF/385723eng.pdf.multi.page=253",
          children: "See latest GEM Report chapter"
        })]
      }), _jsxs(IndicatorTable, {
        children: [_jsx(IndicatorRow, {
          id: "4.2.1",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.2/i4.2.1",
          global: true,
          children: _jsx(_components.p, {
            children: "نسبة الأطفال دون الخامسة الذين يسيرون على المسار الصحيح من حيث النمو في مجالات الصحة والتعلم والرفاه النفسي، بحسب الجنس."
          })
        }), _jsxs(IndicatorRow, {
          id: "4.2.2",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.2/i4.2.2",
          global: true,
          children: [_jsx(_components.p, {
            children: "معدل المشاركة في التعلُّم المنظَّم (قبل سنة واحدة من عمر الالتحاق الرسمي بالتعليم الابتدائي)، بحسب الجنس."
          }), _jsx(ThemeLabel, {
            theme: "access",
            id: "4.2.2"
          })]
        }), _jsx(IndicatorRow, {
          id: "4.2.3",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.2/i4.2.3",
          children: _jsx(_components.p, {
            children: "النسبة المئوية للأطفال دون سن الخامسة الذين يعيشون في بيئة منزلية إيجابية وحافزة للتعلم"
          })
        }), _jsx(IndicatorRow, {
          id: "4.2.4",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.2/i4.2.4",
          children: _jsx(_components.p, {
            children: "نسبة القيد الصافية لتعليم الطفولة المبكرة في (أ) التعليم ما قبل الابتدائي و(ب) برامج تنمية الطفولة المبكرة"
          })
        }), _jsx(IndicatorRow, {
          id: "4.2.5",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.2/i4.2.5",
          children: _jsx(_components.p, {
            children: "عدد سنوات التعليم قبل الابتدائي )1( المجاني و) 2( الإلزامي المضمون بموجب الأطر القانونية"
          })
        })]
      })]
    }), "\n", _jsxs(IndicatorSection, {
      children: [_jsx(_components.h2, {
        id: "target-43",
        children: "Target 4.3"
      }), _jsxs(_components.p, {
        children: ["ضمان تكافؤ فرص جميع النساء والرجال في الحصول على التعليم المهني والتعليم العالي الجيّد والميسور التكلفة، بما في ذلك التعليم الجامعي، بحلول عام 2030\n", _jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000385723/PDF/385723eng.pdf.multi.page=263",
          children: "See latest GEM Report chapter"
        })]
      }), _jsxs(IndicatorTable, {
        children: [_jsx(IndicatorRow, {
          id: "4.3.1",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.3/i4.3.1/",
          global: true,
          children: _jsx(_components.p, {
            children: "معدل مشاركة الشباب و الكبار في التعليم الرسمي وغير الرسمي و التدريب خلال الاثني عشر شهرا السابقة، بحسب الجنس"
          })
        }), _jsx(IndicatorRow, {
          id: "4.3.2",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.3/i4.3.2",
          children: _jsx(_components.p, {
            children: "نسبة القيد الإجمالية في التعليم العالي، بحسب الجنس"
          })
        }), _jsx(IndicatorRow, {
          id: "4.3.3",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.3/i4.3.3",
          children: _jsx(_components.p, {
            children: "نسبة المشاركة في برامج التعليم التقني والمهني )لمن تتراوح أعمارهم بين 15 و 24( بحسب نوع الجنس"
          })
        })]
      })]
    }), "\n", _jsxs(IndicatorSection, {
      children: [_jsx(_components.h2, {
        id: "target-44",
        children: "Target 4.4"
      }), _jsxs(_components.p, {
        children: ["الزيادة بنسبة كبيرة في عدد الشباب والكبار الذين تتوافر لديهم المهارات المناسبة، بما في ذلك المهارات التقنية والمهنية، للعمل وشغل وظائف لائقة ولمباشرة الأعمال الحرة بحلول عام 2030\n", _jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000385723/PDF/385723eng.pdf.multi.page=271",
          children: "See latest GEM Report chapter"
        })]
      }), _jsxs(IndicatorTable, {
        children: [_jsx(IndicatorRow, {
          id: "4.4.1",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.4/i4.4.1",
          global: true,
          children: _jsx(_components.p, {
            children: "نسبة الشباب والكبار الذين تتوفر لديهم مهارات تكنولوجيا المعلومات والاتصالات، بحسب نوع المهارة"
          })
        }), _jsx(IndicatorRow, {
          id: "4.4.2",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.4/i4.4.2",
          children: _jsx(_components.p, {
            children: "النسبة المئوية للشباب و الكبار الذين يحرزون مستوى المعايير الدنيا للكفاءة في مهارات الإدارية الرقمية"
          })
        }), _jsx(IndicatorRow, {
          id: "4.4.3",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.4/i4.4.3",
          children: _jsx(_components.p, {
            children: "معدلات التحصيل التعليمي للشباب و الكبار بحسب الفئة العمرية، ومستوى النشاط الاقتصادي، والمستوى التعليمي، وتوجُّه البرنامج"
          })
        })]
      })]
    }), "\n", _jsxs(IndicatorSection, {
      children: [_jsx(_components.h2, {
        id: "target-45",
        children: "Target 4.5"
      }), _jsxs(_components.p, {
        children: ["القضاء على التفاوت بين الجنسين في التعليم وضمان تكافؤ فرص الوصول إلى جميع مستويات التعليم والتدريب المهني للفئات الضعيفة، بما في ذلك للأشخاص ذوي الإعاقة والشعوب الأصلية والأطفال الذين يعيشون في ظل أوضاع هشة، بحلول عام 2030\n", _jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000385723/PDF/385723eng.pdf.multi.page=281",
          children: "See latest GEM Report chapter"
        })]
      }), _jsxs(IndicatorTable, {
        children: [_jsxs(IndicatorRow, {
          id: "4.5.1",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.5/i.4.5.1",
          global: true,
          children: [_jsx(_components.p, {
            children: "بيانات المساواة (أنثى/ذكر، وريفي/حضري، ومستوى الثراء من القاع إلى القمة ومؤشرات أخرى مثل حالة الإعاقة، والشعوب الأصلية، والمتضررين من النزاعات متى أصبحت البيانات متوافرة) فيما يتعلق بجميع المؤشرات الواردة في هذه القائمة والتي يمكن تصنيفها."
          }), _jsx(ThemeLabel, {
            theme: "equity",
            id: "4.5.1"
          })]
        }), _jsx(IndicatorRow, {
          id: "4.5.2",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.5/i4.5.2",
          children: _jsx(_components.p, {
            children: "النسبة المئوية لتلاميذ التعليم الابتدائي الذين تكون لغتهم الأولى أو لغتهم الأم هي ذاتها لغة التدريس."
          })
        }), _jsx(IndicatorRow, {
          id: "4.5.3",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.5/i4.5.3",
          children: _jsx(_components.p, {
            children: "مدى تخصيص الموارد التعليمية للفئات السكانية المحرومة بالاستناد إلى سياسات قائمة على صيغ صريحة."
          })
        }), _jsx(IndicatorRow, {
          id: "4.5.4",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.5/i4.5.4",
          children: _jsx(_components.p, {
            children: "مبلغ الإنفاق على تعليم التلميذ حسب المستوى التعليمي ومصدر التمويل."
          })
        }), _jsxs(IndicatorRow, {
          id: "4.5.5",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.5/i4.5.5",
          children: [_jsx(_components.p, {
            children: "النسبة المئوية للمساعدة التي تقدم إلى البلدان المنخفضة الدخل من مجموع المساعدات المخصصة للتعليم."
          }), _jsx(ThemeLabel, {
            theme: "finance",
            id: "4.5.5"
          })]
        }), _jsx(IndicatorRow, {
          id: "4.5.6",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.5/i4.5.6",
          children: _jsx(_components.p, {
            children: "الإنفاق التعليمي الأولي بحسب مصدر التمويل  (عام، خاص، دولي) كنسبة مئوية من الناتج المحلي الإجمالي"
          })
        })]
      })]
    }), "\n", _jsxs(IndicatorSection, {
      children: [_jsx(_components.h2, {
        id: "target-46",
        children: "Target 4.6"
      }), _jsxs(_components.p, {
        children: ["ضمان أن يلمّ جميع الشباب ونسبة كبيرة من الكبار، رجالاً ونساءً على حد سواء، بالقراءة والكتابة والحساب بحلول عام 2030\n", _jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000385723/PDF/385723eng.pdf.multi.page=292",
          children: "See latest GEM Report chapter"
        })]
      }), _jsxs(IndicatorTable, {
        children: [_jsxs(IndicatorRow, {
          id: "4.6.1",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.6/i4.6.1",
          global: true,
          children: [_jsx(_components.p, {
            children: "النسبة المئوية للسكان في فئة عمرية معينة الذين يحققون على الأقل مستوى ثابتا من الكفاءة في تصنيفات وظيفية تتناول (أ) الأمية، (ب) المهارات الحسابية، بحسب الجنس."
          }), _jsx(ThemeLabel, {
            theme: "learning",
            id: "4.6.1"
          })]
        }), _jsxs(IndicatorRow, {
          id: "4.6.2",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.6/i4.6.2",
          children: [_jsx(_components.p, {
            children: "معدل إلمام الشباب/الكبار بالقراءة والكتابة."
          }), _jsx(ThemeLabel, {
            theme: "learning",
            id: "4.6.2"
          })]
        })]
      })]
    }), "\n", _jsxs(IndicatorSection, {
      children: [_jsx(_components.h2, {
        id: "target-47",
        children: "Target 4.7"
      }), _jsxs(_components.p, {
        children: ["ضمان أن يكتسب جميع المتعلّمين المعارف والمهارات اللازمة لدعم التنمية المستدامة، بما في ذلك بجملة من السُبُل من بينها التعليم لتحقيق التنمية المستدامة واتّباع أساليب العيش المستدامة، وحقوق الإنسان، والمساواة بين الجنسين، والترويج لثقافة السلام واللاعنف والمواطنة العالمية وتقدير التنوع الثقافي وتقدير مساهمة الثقافة في التنمية المستدامة، بحلول عام 2030. ", _jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000385723/PDF/385723eng.pdf.multi.page=300",
          children: "See latest GEM Report chapter"
        })]
      }), _jsxs(IndicatorTable, {
        children: [_jsx(IndicatorRow, {
          id: "4.7.1",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.7/i4.7.1",
          global: true,
          children: _jsx(_components.p, {
            children: "٤-٧-١ مدى تعميم ’1‘ تعليم المواطنة العالمية و ’2‘ التعليم من أجل التنمية المستدامة، بما في ذلك المساواة بين الجنسين وحقوق الإنسان، وذلك على جميع الصعد في (أ) السياسات التعليمية على الصعيد الوطني، و (ب) المناهج الدراسية و (ج) تدريب المعلمين، و (د) تقييم الطلاب"
          })
        }), _jsx(IndicatorRow, {
          id: "4.7.2",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.7/i4.7.2/",
          children: _jsx(_components.p, {
            children: "النسبة المئوية للمدارس التي تعلّم مهارات حياتية بشأن فيروس نقص المناعة البشرية (HIV) وتقدم تعليماً في التربية الجنسية"
          })
        }), _jsx(IndicatorRow, {
          id: "4.7.3",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.7/i4.7.3",
          children: _jsx(_components.p, {
            children: "مدى تعميم نوايا السياسة الخضراء في وثائق المناهج الدراسية"
          })
        }), _jsx(IndicatorRow, {
          id: "4.7.4",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.7/i4.7.4",
          children: _jsx(_components.p, {
            children: "النسبة المئوية للتلاميذ في المرحلة الأولى من التعليم الثانوي الذين يُظهرون فهما كافياً للمسائل المتعلقة بالمواطنة العالمية والاستدامة"
          })
        }), _jsx(IndicatorRow, {
          id: "4.7.5",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.7/i4.7.5",
          children: _jsx(_components.p, {
            children: "النسبة المئوية للتلاميذ في المرحلة الأولى من التعليم الثانوي الذين يُظهرون الكفاءة في معارف العلوم البيئية وعلوم الأرض"
          })
        })]
      })]
    }), "\n", _jsxs(IndicatorSection, {
      children: [_jsx(_components.h2, {
        id: "target-4a",
        children: "Target 4.a"
      }), _jsxs(_components.p, {
        children: ["بناء المرافق التعليمية التي تراعي الفروق بين الجنسين، والإعاقة، والأطفال، ورفع مستوى المرافق التعليمية القائمة وتهيئة بيئة تعليمية فعالة ومأمونة وخالية من العنف للجميع، بحلول عام2030\n", _jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000385723/PDF/385723eng.pdf.multi.page=308",
          children: "See latest GEM Report chapter"
        })]
      }), _jsxs(IndicatorTable, {
        children: [_jsxs(IndicatorRow, {
          id: "4.a.1",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.a/i4.a.1",
          global: true,
          children: [_jsx(_components.p, {
            children: "أ نسبة المدارس التي تقدم الخدمات الأساسية، بحسب نوع الخدمة"
          }), _jsx(ThemeLabel, {
            theme: "quality",
            id: "4.a.1"
          })]
        }), _jsxs(IndicatorRow, {
          id: "4.a.2",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.a/i4.a.2",
          children: [_jsx(_components.p, {
            children: "النسبة المئوية الطلبة الذين يتعرضون لترهيب، وعقوبات جسدية، ومضايقات، وعنف، وتمييز جنسي واعتداء جنسي."
          }), _jsx(ThemeLabel, {
            theme: "quality",
            id: "4.a.2"
          })]
        }), _jsx(IndicatorRow, {
          id: "4.a.3",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.a/i4.a.3",
          children: _jsx(_components.p, {
            children: "عدد الاعتداءات على الطلبة وأفراد الهيئة التعليمية والمؤسسات."
          })
        }), _jsx(IndicatorRow, {
          id: "4.a.4",
          children: _jsx(_components.p, {
            children: "نسبة الأطفال الملتحقين بالمدارس الذين يتلقون وجبات مدرسية"
          })
        })]
      })]
    }), "\n", _jsxs(IndicatorSection, {
      children: [_jsx(_components.h2, {
        id: "target-4b",
        children: "Target 4.b"
      }), _jsxs(_components.p, {
        children: ["الزيادة بنسبة كبيرة في عدد المنح المدرسية المتاحة للبلدان النامية على الصعيد العالمي للبلدان النامية، وبخاصة لأقل البلدان نموا والدول الجزرية الصغيرة النامية والبلدان الأفريقية، للالتحاق بالتعليم العالي، بما في ذلك منح التدريب المهني وتكنولوجيا المعلومات والاتصالات، والبرامج التقنية والهندسية والعلمية في البلدان المتقدمة النمو والبلدان النامية الأخرى، بحلول عام 2020. ", _jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000385723/PDF/385723eng.pdf.multi.page=321",
          children: "See latest GEM Report chapter"
        })]
      }), _jsx(IndicatorTable, {
        children: _jsx(IndicatorRow, {
          id: "4.b.1",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.b/",
          global: true,
          children: _jsx(_components.p, {
            children: "حجم تدفقات المساعدة الإنمائية الرسمية لتقديم المنح بحسب القطاع ونوع الدراسة."
          })
        })
      })]
    }), "\n", _jsxs(IndicatorSection, {
      children: [_jsx(_components.h2, {
        id: "target-4c",
        children: "Target 4.c"
      }), _jsxs(_components.p, {
        children: ["الزيادة بنسبة كبيرة في عدد المعلمين المؤهلين، بما في ذلك من خلال التعاون الدولي لتدريب المعلمين في البلدان النامية، وبخاصة في أقل البلدان نموًّا والدول الجزرية الصغيرة النامية، بحلول عام 2030. ", _jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000385723/PDF/385723eng.pdf.multi.page=331",
          children: "See latest GEM Report chapter"
        })]
      }), _jsxs(IndicatorTable, {
        children: [_jsxs(IndicatorRow, {
          id: "4.c.1",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.c/i4.c.1",
          global: true,
          children: [_jsx(_components.p, {
            children: "نسبة المعلمين الحاصلين على الحد الأدنى من المؤهلات اللازمة، بحسب المستوى التعليمي"
          }), _jsx(ThemeLabel, {
            theme: "quality",
            id: "4.c.1"
          })]
        }), _jsxs(IndicatorRow, {
          id: "4.c.2",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.c/i4.c.2",
          children: [_jsx(_components.p, {
            children: "متوسط عدد التلاميذ للمدرس المؤهَّل الواحد، بحسب المستوى التعليمي."
          }), _jsx(ThemeLabel, {
            theme: "quality",
            id: "4.c.2"
          })]
        }), _jsx(IndicatorRow, {
          id: "4.c.3",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.c/i4.c.3",
          children: _jsx(_components.p, {
            children: "نسبة المعلمين المؤَهّلين وفقاً للمعايير الوطنية بحسب المستوى التعليمي ونوع المؤسسة التعليمية"
          })
        }), _jsx(IndicatorRow, {
          id: "4.c.4",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.c/i4.c.4",
          children: _jsx(_components.p, {
            children: "متوسط عدد التلاميذ للمدرس المؤهَّل الواحد، بحسب المستوى التعليمي"
          })
        }), _jsx(IndicatorRow, {
          id: "4.c.5",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.c/i4.c.5",
          children: _jsx(_components.p, {
            children: "متوسط أجر المعلمين مقارنة بأجور غيرهم من العاملين في المهن الأخرى التي تتطلب الحصول على مستوى مماثل من المؤهلات التعليمية."
          })
        }), _jsx(IndicatorRow, {
          id: "4.c.6",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.c/i4.c.6",
          children: _jsx(_components.p, {
            children: "معدَّل تناقص أعداد المعلمين بحسب المستوى التعليمي."
          })
        }), _jsx(IndicatorRow, {
          id: "4.c.7",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.c/i4.c.7",
          children: _jsx(_components.p, {
            children: "النسبة المئوية للمعلمين الذين تلقوا تدريباً أثناء الخدمة خلال الأشهر الاثني عشر الأخيرة، بحسب نوع التدريب."
          })
        })]
      })]
    }), "\n", _jsxs(IndicatorSection, {
      children: [_jsx(_components.h2, {
        id: "finance",
        children: "Finance"
      }), _jsx(_components.p, {
        children: _jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000385723/PDF/385723eng.pdf.multi.page=340",
          children: "See latest GEM Report chapter"
        })
      }), _jsxs(IndicatorTable, {
        children: [_jsxs(IndicatorRow, {
          id: "F.1",
          children: [_jsx(_components.p, {
            children: "الإنفاق الحكومي على التعليم كنسبة مئوية من الناتج المحلي الإجمالي"
          }), _jsx(ThemeLabel, {
            theme: "finance",
            id: "F.1"
          })]
        }), _jsxs(IndicatorRow, {
          id: "F.2",
          children: [_jsx(_components.p, {
            children: "الإنفاق الحكومي على التعليم كنسبة مئوية من إجمالي الإنفاق الحكومي"
          }), _jsx(ThemeLabel, {
            theme: "finance",
            id: "F.2"
          })]
        })]
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
